import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import TableText from "../TableText";
import { columnsData } from './data';
import { toJS, runInAction, action } from 'mobx';

const { TextArea } = Input;

@inject('store')
@observer
class App extends Component {
    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.monthlyAnalysis.data);
        data[i][name] = value;
        this.props.store.monthlyAnalysis.data = data;
    }
    render() {
        const { data, notes, loading } = this.props.store.monthlyAnalysis;
        const width = document.body.offsetWidth > 2100 ? document.body.offsetWidth - 1800 : 300;
        const columns = columnsData.map(item => {
            if (item.key == 'name') {
                return {
                    title: item.title,
                    dataIndex: item.key,
                    key: item.key,
                    fixed: 'left',
                    width,
                    render: (text, record, index) => {
                        const props = {
                            text,
                            index: 9 + index,
                            type: item.type,
                            name: item.key,
                            onChange: this.onChange,
                            totalIndex: [],

                        };
                        return <TableText data={{ ...props }} />
                    }
                }
            }
            return {
                title: item.title,
                dataIndex: item.key,
                key: item.key,
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text: record[item.key + 'minus'] ? "扭亏为盈" : text,
                        index: 9 + index,
                        type: record[item.key + 'minus'] ? "text" : item.type,
                        name: item.key,
                        onChange: this.onChange,
                        totalIndex: [],
                        compared: {
                            title: [item.title],
                            record,
                            sqlName: "monthlyAnalysis"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }
        })
        return (
            <div className="">
                <Row className="secondary_title">五．经营预测分析</Row>
                <div className="text_c"><span className="span_41">（1）</span>销售收入增长率=（本期销售收入-上期销售收入）/上期销售收入*100%</div>
                <div className="text_c text_indent m_b_10">一般销售收入增长率越高越好</div>
                <div className="text_c"><span className="span_41">（2）</span>经营毛利润增长率=（本期经营毛利润-上期经营毛利润）/上期经营毛利润*100%</div>
                <div className="text_c text_indent m_b_10">一般经营毛利润增长率越高越好</div>
                <Table
                    columns={columns}
                    dataSource={data.slice(9, 11)}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                    scroll={{ x: 2100 }}
                />
                <Row className="note_title">酒店的经营预测趋势分析</Row>
                {!loading && <TextArea
                    className="note m_b_80"
                    autosize={{ minRows: 8 }}
                    defaultValue={notes.business}
                    onBlur={e => {
                        runInAction(() => {
                            this.props.store.monthlyAnalysis.notes.business = e.target.value || "";
                        })
                    }}
                    placeholder={`示例：\n（1）对比上期销售收入增加或减少的原因？\n（2）对比上期经营毛利润增加或减少的原因？`}
                />}
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/businessForecast.js